export const PrerenderPrefecturesCodeList = [1];

export const PrerenderCompanyCitiesDefaultPageList = [1101] as const;

export const PrerenderCompanyCitiesAnyProperties = [1101] as const;

export const PrerenderCompanyCitiesLand = [1101] as const;

export const PrerenderCompanyCitiesDivorce = [1101] as const;

export const PrerenderCompanyCitiesSellHigh = [1101] as const;

export const PrerenderCompanyCitiesPurchase = [1101] as const;

export const PrerenderCompanyCitiesHouse = [1101] as const;

export const PrerenderCompanyCitiesInheritance = [1101] as const;

export const PrerenderCompanyCitiesLeaseback = [1101] as const;

export const PrerenderCompanyCitiesAkiya = [1101] as const;

export const PrerenderCompanyCitiesMansion = [1101] as const;

export const PrerenderCompanyCitiesSellFast = [1101] as const;

export const PrerenderCompanyDetail = [1101] as const;

export const PrerenderMansionCityCodeList = [1101] as const;

export const PrerenderMansionDetailIdList = [1101] as const;

export const PrerenderLandhouseCityCodeList = [1101] as const;

export const PrerenderLandhouseTownCodeList = [1101] as const;

export const PrerenderInterviewDetail = [1] as const;
